import React, {ReactNode} from 'react';
import MUIDialog, {DialogProps as MUIDialogProps} from '@material-ui/core/Dialog';
import classNames from 'classnames';
import './dialogModal.less';

export interface DialogProps extends Omit<MUIDialogProps, 'open' | 'title' | 'content'> {
    isOpen: boolean;
    title?: ReactNode;
    content?: ReactNode;
    actions?: ReactNode;
    className?: string;
    children?: ReactNode;
    titleProps?: React.HTMLAttributes<HTMLHeadingElement>;
    contentProps?: React.HTMLAttributes<HTMLDivElement>;
    actionsProps?: React.HTMLAttributes<HTMLDivElement>;
    fullWidth?: boolean;
    classes?: MUIDialogProps['classes'];
}

export const Dialog = ({
    isOpen,
    title,
    content,
    actions,
    className,
    children,
    titleProps,
    contentProps,
    actionsProps,
    fullWidth = false,
    classes,
    ...restProps
}: DialogProps) => {
    const containerClassName = classNames('dialog', className, {'dialog-full-width': fullWidth});

    return (
        <MUIDialog
            open={isOpen}
            classes={{root: containerClassName, ...classes}}
            {...restProps}
        >
            {children || (
                <>
                    {title && (
                        <h2 className="title" {...titleProps}>
                            {title}
                        </h2>
                    )}
                    {content && (
                        <div className="content" {...contentProps}>
                            {content}
                        </div>
                    )}
                    {actions && (
                        <div className="actions" {...actionsProps}>
                            {actions}
                        </div>
                    )}
                </>
            )}
        </MUIDialog>
    );
};
